import { TermAgreementRequest } from '../../../constants/types/term-type';
import instance from '../../axios/utils.ts/instance';

/**
 * 약관 동의 기록 (단건)
 * @param body
 * @returns
 */
export const postTermAgreement = async (body: TermAgreementRequest) => {
  const response = await instance.post('/v1/product/app/terms/agree', body);
  return response.data;
};

/**
 * 약관 동의 기록 (여러 건)
 * @param body
 * @returns
 */
export const postTermAgreements = async (body: {
  agreements: TermAgreementRequest[];
}) => {
  const response = await instance.post(
    '/v1/product/app/terms/agree/bulk',
    body,
  );
  return response.data;
};
